import { TeaConfig } from '../../../contracts/common/tea.model';
import { SeverityOfHarm } from '../../../contracts/common/severity-harm.model';
import { DateRange } from '../../../contracts/common/date-range.model';
import { GroupType } from '../../../contracts/common/group-type.model';
import { QcRule } from '../../../contracts/common/qc-rule.model';

export interface ICommonDataState {
    allTeaConfigs: TeaConfig[];
    qcRules: QcRule[];
    severityOfHarmValues: SeverityOfHarm[];
    dateRangeValues: DateRange[];
    groupTypes: GroupType[];
}

const initialState: ICommonDataState = {
    allTeaConfigs: [],
    qcRules: [],
    severityOfHarmValues: [],
    dateRangeValues: [],
    groupTypes: []
};

export default initialState;



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/modules/common-data/ICommonDataState.ts